import React from "react";
import styled from "styled-components";

export const ContentAd = ({
  title,
  subtitle,
  bgImage,
  playIcon,
  setModalVisible,
}) => {
  return (
    <ContentAdContainer bgImage={bgImage}>
      <ContentAdOverlay>
        <ModalLink onClick={setModalVisible}>
          <PlayButton src={playIcon} />
          <AdText>
            <AdTitle>{title}</AdTitle>
            <AdSubtitle>{subtitle}</AdSubtitle>
          </AdText>
        </ModalLink>
      </ContentAdOverlay>
    </ContentAdContainer>
  );
};

const ContentAdContainer = styled.div`
  display: flex;
  background-image: url(${(props) => props.bgImage});
  background-position: center;
  background-size: cover;
  padding-top: 56.25%;
  position: relative;
`;

const ContentAdOverlay = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 35%,
    rgba(0, 0, 0, 0) 35%
  );
  padding: 30px;
  align-items: center;
  justify-content: center;
  color: #ffffff;
`;

const PlayButton = styled.img`
  width: 15%;
  margin-right: 15px;
`;

const AdText = styled.div`
  display: flex;
  flex-direction: column;
`;

const AdTitle = styled.h3`
  font-size: 40px;
  font-family: ${(props) => props.theme.fontStacks.header};
  text-transform: uppercase;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 41px;
  }

  @media only screen and ${(props) => props.theme.maxMedia.large} {
    font-size: 45px;
  }
`;

const AdSubtitle = styled.p`
  font-size: 22px;
  margin-left: 17px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    margin-left: 12px;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 25px;
  }
`;

const ModalLink = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }
`;
